export default "__VITE_PUBLIC_ASSET__ae64ab80__"